import { TableContainer, Box } from "@mui/material";
import styled from "styled-components";

export const BundleTableBox = styled(Box)`
  .noquotecell {
    height: 100px;
    border-bottom: none;
  }
  .noquotetext {
    align-items: center;
  }
  .paginationContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    h6 {
      color: #1b4a83;
      font-weight: 600;
      font-family: "Noto Sans", sans-serif;
      span {
        font-size: 14px;
        font-weight: 500;
        color: #000;
        padding-left: 6px;
        font-family: "Noto Sans", sans-serif;
      }
    }
    button {
      margin: 10px 0;
      border-radius: 2px;
      font-family: "Noto Sans", sans-serif;
    }
  }
`;

export const BundleTableContainerWrapper = styled(TableContainer)`


.bundleTableContainer{  
    margin-top:0.4%;
    padding:0px 4px;
    max-height:100px !important;
    table{
     thead{
        background-color: #1B4A83;
        text-wrap: nowrap;

        tr{
            th{
                color: #fff;
                font-weight: bold;
                text-align: left;
                font-size: 12px;
                padding:10px;
                // background-color: #1B4A83;
      @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
      font-size: 14px;
     font-weight: 400;

   }
}

.css-1qgma8u-MuiButtonBase-root-MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
    opacity: 1;
    color: #fff;
}
 .MuiTableSortLabel-icon {
    opacity: 1;
    color:white;
    font-size:20px;
}

                .filterBar{
                    margin: -5px 8px;
                    font-size: 18px;
                        @media screen and (min-device-width: 1190px) and (max-device-width: 1288px) { 
    margin: -3px 8px;


 }
                }
            }
        }
     }
     tbody{
        text-wrap: nowrap;
        tr{
            td{
                text-align: start;
                svg{

                }
            }
            th{
                
            }
        }
    }

}

}
.noDataRow{
    border-bottom:none;
    align-content:center;
}

.fixedColumnone{
    color: #1B4A83;
}
`
;

export const statusColors = {
  "Pending Approval": "#8A9123",
  "Pending Initial Requestor": "#E27900",
  Approved: "#00AF97",
  Submitted: "#239155",
  Contracted: "#91238D",
  // Add more status values and colors as needed
};

/** For Bundle Component **/
export const DropdownWrap = styled(Box)`
  align-items: center;
  width: 100%;
  flex-direction: column;
  margin: 0.1% auto;
  font-family: sans-serif;
  .compareButton {
    width: 200px;
    background: #03715b;
    text-transform: capitalize;
    :hover {
      background: #03715b;
    }
  }
  .listAccTxt {
    color: #949494;
  }
  .listItemqq {
    border-bottom: 1px solid #bdcadb;
    height: 10px;
  }
  .noBundleText {
    display: flex;
    align-items: center;
    gap: 1px;
  }
  .currentNoData {
    min-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .chip {
    color: #2b578c;
    border-radius: 5px;
    width: 160px;
    border: 1px solid #1b4a83;
  }
  .buttonContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 15px;
    gap: 10px;
  }
  .infoContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;
  }
  .infoIcon {
    color: #1b4a83;
    font-size: 14px;
    padding-left: 2px;
  }
  .infotext {
    color: #1b4a83;
    font-size: 13px;
  }
  .bundleButton {
    width: 120]px;
    background: #239155;
    text-transform: capitalize;
    :hover {
      background: #239155;
    }
  }
  .MuiAccordionSummary-content {
    align-items: center;
    justify-content: space-between;
  }
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }
  .MuiAccordion-root.Mui-disabled {
    background-color: #8a8a8a;
    color: #fff;
  }
  .MuiAccordionSummary-root.Mui-disabled {
    opacity: 1;
  }
  .bundleAccordion {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .currentNoData {
    min-height: 100px;
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .currentHeadingBox {
    background: #1b4a83;
    color: white;
    font-weight: 600;
    border-radius: 3px 3px 0px 0px;
  }
  .approveButton {
    color: #239155;
    text-transform: capitalize;
    font-weight: 600;
    padding: 0px;
  }
  .removeButtonWrap {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }
  .removeButton {
    color: #a62632;
    font-weight: 600;
    text-transform: capitalize;
    // z-index: 1;
    // position: absolute;
    // top: 50px;
    // right: 40px;
  }
  .bundleTableBoxHead {
    color: #1b4a83;
    background: #f5f5f5;
    font-weight: 600;
    border-radius: 3px 3px 0px 0px;
  }
  .bundleAccordianHeaderTable {
    table {
      table-layout: fixed;
    }
    th {
      width: 1%;
    }
  }
.ellipsis {
  text-align: left;
  padding: 0;
  white-space: nowrap; /* Prevent text from wrapping */
}
  .ellipsis:before {
    visibility: hidden;
  }
  

  .accountDataBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .bundledAccountDataBox {
    gap: 10px;
  }
  .revenueCard {
    min-height: 115px;
    // border: none;
    box-shadow: none;
    display: flex;
    width: 20%;
    justify-content: flex-start;
    align-items: center;
  }
  .dataCard {
    border: 1px solid #1b4a83;
    width: 24%;
    min-height: 90px;
  }
  .cardContent {
    display: flex;
    align-items: flex-start;
    gap: 6px;
  }
  .revenueCardContent {
    display: flex;
    text-align: left;
    flex-direction: column;
  }
  .dataDiv {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .revenueCardHeader {
    color: #376092;
    display: flex;
    gap: 5px;
  }
  .dataCardHeader {
    color: #376092;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .dataCardData {
    font-weight: 600;
  }
  .tableContainer {
    padding: 0px;
    text-wrap: balance;
  }
  .noBundleText {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .action-buttons-container {
    display: flex;
    gap: 5%;
  }
  .bundleActionContainer {
    display: flex;
    align-items: center;
    color: #1b4a83;
    border: 1px solid #1b4a83;
    border-radius: 5px;
    padding: 1%;
    margin: 1%;
    gap: 1%;
  }
  .discountTitleAndDescription {
    flex-direction: column;
    display: inline-flex;
  }
  .greytext-light {
    color: #777777c2;
  }
  .bundleActions {
    align-items: center;
    gap: 1%;
  }
  .txtDiscountContainer {
    min-width: 25% !important;
  }
  .txtDiscount {
    font-size: 14px;
    .MuiInputBase-input {
      background-color: #fff;
      height: 0.2275em;
      border-radius: 5px;
      font-family: "Noto Sans", sans-serif;
    }
  }
  .btnSwitchToPercentOrValue {
    text-transform: unset !important;
    border-color: #1b4a83;
    color: #1b4a83;
    min-width: 25% !important;
  }
  .btnPreviewDiscount {
    text-transform: unset !important;
    color: #1b4a83;
    min-width: 25% !important;
  }
  .btnSaveBundleActive {
    text-transform: unset !important;
    border-color: #1b4a83;
    color: #fff;
    background-color: #1b4a83;
  }

  .btnApproveContainer {
    display: flex;
    width: 100%;
    gap: 1%;
  }

  .btnApproveBundleActive {
    text-transform: unset !important;
    border-color: #1b4a83;
    color: #fff;
    background-color: #1b4a83;
  }
  .btnSaveBundleInActive {
    text-transform: unset !important;
    border-color: #1b4a83;
    color: #777777;
    background-color: #0000002e;
    width: 6%;
  }
  .btnApproveBundleInActive {
    text-transform: unset !important;
    border-color: #1b4a83;
    color: #777777;
    background-color: #777777c2;
  }

  .btnSubmitActive {
    width: 120px;
    background: #239155;
    text-transform: capitalize;
    :hover {
      background: #239155;
    }
  }

  .btnSubmitInActive {
    width: 120px;
    color: #777777;
    background-color: #777777c2;
    text-transform: capitalize;
  }

  span.error {
    color: #d32f2f;
    line-height: 1;
    font-size: 14px;
    font-weight: 400;
    font-family: "Noto Sans", sans-serif;
  }

  .btnRefresh {
    text-transform: unset !important;
    color: #1b4a83;
  }

  .bundleButtonsWrapper {
    display: flex;
    justify-content: flex-end;
  }
  .tableSection {
    margin-top: 1%;
  }
`;
